import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { CheckoutDeliveryAddressComponent, CheckoutStepService } from '@spartacus/checkout/base/components';
import { CheckoutDeliveryAddressFacade, CheckoutDeliveryModesFacade } from '@spartacus/checkout/base/root';
import { GlobalMessageService, TranslationService, UserAddressService, Address, RoutingService } from '@spartacus/core';
import { ModalService } from '../../../../../../components/modal-list/modal-list.service';
import { Subscription, switchMap, take } from 'rxjs';
import { AddressBookComponentService } from '@spartacus/user/profile/components';
import { CheckoutAuxService } from '../../../b2b/core/checkout-aux.service';
import { CustomActiveCartService } from '../../../../cart/_core/active-cart.service';
import { ToasterService } from '../../../../../../components/toaster/toaster.service';
import { TOASTER_TYPE } from '../../../../../../components/toaster/toaster.model';
import { ADDRESS_TYPE } from '../../../../../../core/models/address.model';

@Component({
  selector: 'cx-delivery-address',
  templateUrl: './checkout-delivery-address.component.html',
  styleUrl: './checkout-delivery-address.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomCheckoutDeliveryAddressComponent
  extends CheckoutDeliveryAddressComponent
  implements OnInit, OnDestroy
{
  ADDRESS_TYPE = ADDRESS_TYPE;
  cart$ = this.customActiveCartService.getActive();

  constructor(
    private _userAddressService: UserAddressService,
    private _checkoutDeliveryAddressFacade: CheckoutDeliveryAddressFacade,
    private _activatedRoute: ActivatedRoute,
    private _translationService: TranslationService,
    private _activeCartFacade: ActiveCartFacade,
    private _checkoutStepService: CheckoutStepService,
    private _checkoutDeliveryModesFacade: CheckoutDeliveryModesFacade,
    private _globalMessageService: GlobalMessageService,
    private modalService: ModalService,
    public addressBookService: AddressBookComponentService,
    public checkoutAuxService: CheckoutAuxService,
    public customActiveCartService: CustomActiveCartService,
    public toasterService: ToasterService,
    protected routingService: RoutingService,
  ) {
    super(
      _userAddressService,
      _checkoutDeliveryAddressFacade,
      _activatedRoute,
      _translationService,
      _activeCartFacade,
      _checkoutStepService,
      _checkoutDeliveryModesFacade,
      _globalMessageService,
    );
  }

  subscription = new Subscription();

  override ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  // eslint-disable-next-line
  override selectDefaultAddress(addresses: Address[], selected: Address | undefined): void {}

  customSelectAddress(address: Address): void {
    this.busy$.next(true);

    this.checkoutDeliveryAddressFacade
      .setDeliveryAddress(address)
      .pipe(switchMap(() => this.checkoutDeliveryModesFacade.clearCheckoutDeliveryMode()))
      .subscribe({
        complete: () => {
          if (!address.dropShippingAddress) {
            this.toasterService.init({
              type: TOASTER_TYPE.INFO,
              timeToClose: 10000,
              content: 'We`ll need to recalculate some items based on the <strong>Ship To</strong> address.',
            });

            this.routingService.go(['/cart']);
            this.modalService.close();
          }

          this.busy$.next(false);
        },
        error: () => {
          this.busy$.next(false);
        },
      });
  }

  override addAddress(address: Address | undefined): void {
    this.checkoutAuxService
      .createAddress(address!)
      .pipe(take(1))
      .subscribe(addressRequest => {
        if (addressRequest.hasError) {
          this.toasterService.init({
            type: TOASTER_TYPE.DANGER,
            content: addressRequest.message || '',
          });
        } else {
          if (addressRequest.address?.id) {
            this.customSelectAddress(addressRequest.address!);
            this.addressBookService.loadAddresses();
            this.close();
          }

          this.hideNewAddressForm(false);
        }
      });
  }

  close() {
    this.modalService.close();
  }
}
